var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 540,
    viewBox: "0 0 1440 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10831_123661",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -230,
    width: 1440,
    height: 1080
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -230,
    width: 1440,
    height: 1080,
    fill: "url(#paint0_radial_10831_123661)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10831_123661)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10831_123661)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    transform: "translate(0 -230)",
    fill: "#0E122F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.923 161.846C978.923 162.948 978.485 164.004 977.706 164.783C976.927 165.562 975.871 166 974.769 166H969.231V157.692H974.769C975.871 157.692 976.927 158.13 977.706 158.909C978.485 159.688 978.923 160.744 978.923 161.846ZM990 166C990 169.56 988.944 173.04 986.966 176C984.989 178.96 982.177 181.267 978.888 182.63C975.599 183.992 971.98 184.349 968.488 183.654C964.997 182.96 961.789 181.245 959.272 178.728C956.755 176.211 955.04 173.003 954.346 169.512C953.651 166.02 954.008 162.401 955.37 159.112C956.733 155.823 959.04 153.011 962 151.034C964.96 149.056 968.44 148 972 148C976.772 148.005 981.348 149.903 984.722 153.278C988.097 156.652 989.995 161.228 990 166ZM981.692 161.846C981.692 160.937 981.513 160.037 981.165 159.197C980.817 158.357 980.307 157.594 979.665 156.951C979.022 156.308 978.259 155.798 977.419 155.45C976.579 155.102 975.678 154.923 974.769 154.923H967.846C967.479 154.923 967.127 155.069 966.867 155.329C966.607 155.588 966.462 155.94 966.462 156.308V166H965.077C964.71 166 964.358 166.146 964.098 166.406C963.838 166.665 963.692 167.017 963.692 167.385C963.692 167.752 963.838 168.104 964.098 168.364C964.358 168.623 964.71 168.769 965.077 168.769H966.462V171.538H965.077C964.71 171.538 964.358 171.684 964.098 171.944C963.838 172.204 963.692 172.556 963.692 172.923C963.692 173.29 963.838 173.642 964.098 173.902C964.358 174.162 964.71 174.308 965.077 174.308H966.462V177.077C966.462 177.444 966.607 177.796 966.867 178.056C967.127 178.316 967.479 178.462 967.846 178.462C968.213 178.462 968.566 178.316 968.825 178.056C969.085 177.796 969.231 177.444 969.231 177.077V174.308H976.154C976.521 174.308 976.873 174.162 977.133 173.902C977.393 173.642 977.538 173.29 977.538 172.923C977.538 172.556 977.393 172.204 977.133 171.944C976.873 171.684 976.521 171.538 976.154 171.538H969.231V168.769H974.769C975.678 168.769 976.579 168.59 977.419 168.242C978.259 167.894 979.022 167.384 979.665 166.742C980.307 166.099 980.817 165.335 981.165 164.495C981.513 163.656 981.692 162.755 981.692 161.846Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 148C1328.44 148 1324.96 149.056 1322 151.034C1319.04 153.011 1316.73 155.823 1315.37 159.112C1314.01 162.401 1313.65 166.02 1314.35 169.512C1315.04 173.003 1316.75 176.211 1319.27 178.728C1321.79 181.245 1325 182.96 1328.49 183.654C1331.98 184.349 1335.6 183.992 1338.89 182.63C1342.18 181.267 1344.99 178.96 1346.97 176C1348.94 173.04 1350 169.56 1350 166C1349.99 161.228 1348.1 156.652 1344.72 153.278C1341.35 149.903 1336.77 148.005 1332 148ZM1340.31 164.615H1333.38V177.077C1333.38 177.444 1333.24 177.796 1332.98 178.056C1332.72 178.316 1332.37 178.462 1332 178.462C1331.63 178.462 1331.28 178.316 1331.02 178.056C1330.76 177.796 1330.62 177.444 1330.62 177.077V164.615H1323.69C1323.33 164.615 1322.97 164.47 1322.71 164.21C1322.45 163.95 1322.31 163.598 1322.31 163.231C1322.31 162.864 1322.45 162.511 1322.71 162.252C1322.97 161.992 1323.33 161.846 1323.69 161.846H1340.31C1340.67 161.846 1341.03 161.992 1341.29 162.252C1341.55 162.511 1341.69 162.864 1341.69 163.231C1341.69 163.598 1341.55 163.95 1341.29 164.21C1341.03 164.47 1340.67 164.615 1340.31 164.615ZM1340.31 159.077H1323.69C1323.33 159.077 1322.97 158.931 1322.71 158.671C1322.45 158.412 1322.31 158.06 1322.31 157.692C1322.31 157.325 1322.45 156.973 1322.71 156.713C1322.97 156.454 1323.33 156.308 1323.69 156.308H1340.31C1340.67 156.308 1341.03 156.454 1341.29 156.713C1341.55 156.973 1341.69 157.325 1341.69 157.692C1341.69 158.06 1341.55 158.412 1341.29 158.671C1341.03 158.931 1340.67 159.077 1340.31 159.077Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.75 219.75C1112.19 219.75 1108.71 220.806 1105.75 222.784C1102.79 224.761 1100.48 227.573 1099.12 230.862C1097.76 234.151 1097.4 237.77 1098.1 241.262C1098.79 244.753 1100.5 247.961 1103.02 250.478C1105.54 252.995 1108.75 254.71 1112.24 255.404C1115.73 256.099 1119.35 255.742 1122.64 254.38C1125.93 253.017 1128.74 250.71 1130.72 247.75C1132.69 244.79 1133.75 241.31 1133.75 237.75C1133.74 232.978 1131.85 228.402 1128.47 225.028C1125.1 221.653 1120.52 219.755 1115.75 219.75ZM1115.75 233.596C1116.12 233.596 1116.47 233.742 1116.73 234.002C1116.99 234.261 1117.13 234.614 1117.13 234.981C1117.13 235.348 1116.99 235.7 1116.73 235.96C1116.47 236.22 1116.12 236.365 1115.75 236.365H1108.83V239.135H1112.98C1113.35 239.135 1113.7 239.28 1113.96 239.54C1114.22 239.8 1114.37 240.152 1114.37 240.519C1114.37 240.886 1114.22 241.239 1113.96 241.498C1113.7 241.758 1113.35 241.904 1112.98 241.904H1108.97C1109.21 243.097 1109.76 244.206 1110.57 245.117C1111.38 246.028 1112.42 246.709 1113.57 247.092C1114.73 247.475 1115.97 247.546 1117.16 247.299C1118.35 247.051 1119.46 246.492 1120.37 245.68C1120.5 245.552 1120.66 245.452 1120.83 245.386C1121.01 245.321 1121.19 245.291 1121.38 245.298C1121.56 245.305 1121.74 245.35 1121.91 245.429C1122.08 245.508 1122.23 245.62 1122.35 245.758C1122.48 245.897 1122.57 246.059 1122.63 246.235C1122.69 246.41 1122.72 246.596 1122.7 246.781C1122.69 246.967 1122.64 247.147 1122.55 247.312C1122.47 247.478 1122.35 247.624 1122.21 247.743C1120.9 248.912 1119.31 249.704 1117.58 250.035C1115.86 250.367 1114.08 250.226 1112.44 249.626C1110.79 249.027 1109.34 247.993 1108.23 246.633C1107.12 245.273 1106.41 243.639 1106.16 241.904H1104.67C1104.31 241.904 1103.95 241.758 1103.69 241.498C1103.43 241.239 1103.29 240.886 1103.29 240.519C1103.29 240.152 1103.43 239.8 1103.69 239.54C1103.95 239.28 1104.31 239.135 1104.67 239.135H1106.06V236.365H1104.67C1104.31 236.365 1103.95 236.22 1103.69 235.96C1103.43 235.7 1103.29 235.348 1103.29 234.981C1103.29 234.614 1103.43 234.261 1103.69 234.002C1103.95 233.742 1104.31 233.596 1104.67 233.596H1106.16C1106.41 231.861 1107.12 230.227 1108.23 228.867C1109.34 227.507 1110.79 226.473 1112.44 225.874C1114.08 225.274 1115.86 225.133 1117.58 225.465C1119.31 225.796 1120.9 226.588 1122.21 227.757C1122.35 227.876 1122.47 228.022 1122.55 228.188C1122.64 228.353 1122.69 228.533 1122.7 228.719C1122.72 228.904 1122.69 229.09 1122.63 229.265C1122.57 229.441 1122.48 229.603 1122.35 229.741C1122.23 229.88 1122.08 229.992 1121.91 230.071C1121.74 230.15 1121.56 230.195 1121.38 230.202C1121.19 230.209 1121.01 230.179 1120.83 230.114C1120.66 230.048 1120.5 229.948 1120.37 229.82C1119.46 229.008 1118.35 228.449 1117.16 228.201C1115.97 227.954 1114.73 228.025 1113.57 228.408C1112.42 228.791 1111.38 229.472 1110.57 230.383C1109.76 231.294 1109.21 232.403 1108.97 233.596H1115.75Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 292C896.44 292 892.96 293.056 890 295.034C887.04 297.011 884.733 299.823 883.37 303.112C882.008 306.401 881.651 310.02 882.346 313.512C883.04 317.003 884.755 320.211 887.272 322.728C889.789 325.245 892.997 326.96 896.488 327.654C899.98 328.349 903.599 327.992 906.888 326.63C910.177 325.267 912.989 322.96 914.966 320C916.944 317.04 918 313.56 918 310C917.995 305.228 916.097 300.652 912.722 297.278C909.348 293.903 904.772 292.005 900 292ZM906.632 304.462H908.308C908.675 304.462 909.027 304.607 909.287 304.867C909.546 305.127 909.692 305.479 909.692 305.846C909.692 306.213 909.546 306.566 909.287 306.825C909.027 307.085 908.675 307.231 908.308 307.231H906.89C906.715 309.122 905.841 310.879 904.439 312.16C903.036 313.44 901.207 314.151 899.308 314.154H897.113L906.388 321.369C906.539 321.478 906.666 321.617 906.762 321.776C906.858 321.935 906.921 322.112 906.947 322.296C906.973 322.48 906.962 322.667 906.914 322.847C906.866 323.026 906.783 323.194 906.669 323.341C906.555 323.488 906.412 323.61 906.25 323.7C906.088 323.791 905.909 323.848 905.724 323.868C905.539 323.887 905.352 323.87 905.174 323.816C904.996 323.762 904.831 323.673 904.689 323.554L892.227 313.861C892 313.684 891.833 313.44 891.751 313.164C891.669 312.888 891.675 312.593 891.769 312.32C891.862 312.047 892.039 311.81 892.273 311.643C892.508 311.475 892.789 311.385 893.077 311.385H899.308C900.473 311.384 901.599 310.965 902.48 310.202C903.361 309.439 903.937 308.384 904.104 307.231H893.077C892.71 307.231 892.358 307.085 892.098 306.825C891.838 306.566 891.692 306.213 891.692 305.846C891.692 305.479 891.838 305.127 892.098 304.867C892.358 304.607 892.71 304.462 893.077 304.462H903.685C903.292 303.633 902.672 302.933 901.897 302.443C901.122 301.953 900.225 301.693 899.308 301.692H893.077C892.71 301.692 892.358 301.546 892.098 301.287C891.838 301.027 891.692 300.675 891.692 300.308C891.692 299.94 891.838 299.588 892.098 299.329C892.358 299.069 892.71 298.923 893.077 298.923H908.308C908.675 298.923 909.027 299.069 909.287 299.329C909.546 299.588 909.692 299.94 909.692 300.308C909.692 300.675 909.546 301.027 909.287 301.287C909.027 301.546 908.675 301.692 908.308 301.692H905.178C905.85 302.504 906.345 303.448 906.632 304.462Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.54 314.154C1265.54 314.888 1265.25 315.593 1264.73 316.112C1264.21 316.631 1263.5 316.923 1262.77 316.923H1261.38V311.385H1262.77C1263.5 311.385 1264.21 311.676 1264.73 312.196C1265.25 312.715 1265.54 313.419 1265.54 314.154ZM1278 310C1278 313.56 1276.94 317.04 1274.97 320C1272.99 322.96 1270.18 325.267 1266.89 326.63C1263.6 327.992 1259.98 328.349 1256.49 327.654C1253 326.96 1249.79 325.245 1247.27 322.728C1244.75 320.211 1243.04 317.003 1242.35 313.512C1241.65 310.02 1242.01 306.401 1243.37 303.112C1244.73 299.823 1247.04 297.011 1250 295.034C1252.96 293.056 1256.44 292 1260 292C1264.77 292.005 1269.35 293.903 1272.72 297.278C1276.1 300.652 1277.99 305.228 1278 310ZM1268.31 314.154C1268.31 312.685 1267.72 311.276 1266.69 310.238C1265.65 309.199 1264.24 308.615 1262.77 308.615H1261.38V303.077H1262.08C1262.81 303.077 1263.52 303.369 1264.04 303.888C1264.55 304.407 1264.85 305.112 1264.85 305.846C1264.85 306.213 1264.99 306.566 1265.25 306.825C1265.51 307.085 1265.86 307.231 1266.23 307.231C1266.6 307.231 1266.95 307.085 1267.21 306.825C1267.47 306.566 1267.62 306.213 1267.62 305.846C1267.62 304.377 1267.03 302.969 1265.99 301.93C1264.95 300.891 1263.55 300.308 1262.08 300.308H1261.38V298.923C1261.38 298.556 1261.24 298.204 1260.98 297.944C1260.72 297.684 1260.37 297.538 1260 297.538C1259.63 297.538 1259.28 297.684 1259.02 297.944C1258.76 298.204 1258.62 298.556 1258.62 298.923V300.308H1257.92C1256.45 300.308 1255.05 300.891 1254.01 301.93C1252.97 302.969 1252.38 304.377 1252.38 305.846C1252.38 307.315 1252.97 308.724 1254.01 309.762C1255.05 310.801 1256.45 311.385 1257.92 311.385H1258.62V316.923H1257.23C1256.5 316.923 1255.79 316.631 1255.27 316.112C1254.75 315.593 1254.46 314.888 1254.46 314.154C1254.46 313.787 1254.32 313.434 1254.06 313.175C1253.8 312.915 1253.44 312.769 1253.08 312.769C1252.71 312.769 1252.36 312.915 1252.1 313.175C1251.84 313.434 1251.69 313.787 1251.69 314.154C1251.69 315.623 1252.28 317.031 1253.31 318.07C1254.35 319.109 1255.76 319.692 1257.23 319.692H1258.62V321.077C1258.62 321.444 1258.76 321.796 1259.02 322.056C1259.28 322.316 1259.63 322.462 1260 322.462C1260.37 322.462 1260.72 322.316 1260.98 322.056C1261.24 321.796 1261.38 321.444 1261.38 321.077V319.692H1262.77C1264.24 319.692 1265.65 319.109 1266.69 318.07C1267.72 317.031 1268.31 315.623 1268.31 314.154ZM1255.15 305.846C1255.15 306.581 1255.45 307.285 1255.96 307.804C1256.48 308.324 1257.19 308.615 1257.92 308.615H1258.62V303.077H1257.92C1257.19 303.077 1256.48 303.369 1255.96 303.888C1255.45 304.407 1255.15 305.112 1255.15 305.846Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 364C1040.44 364 1036.96 365.056 1034 367.034C1031.04 369.011 1028.73 371.823 1027.37 375.112C1026.01 378.401 1025.65 382.02 1026.35 385.512C1027.04 389.003 1028.75 392.211 1031.27 394.728C1033.79 397.245 1037 398.96 1040.49 399.654C1043.98 400.349 1047.6 399.992 1050.89 398.63C1054.18 397.267 1056.99 394.96 1058.97 392C1060.94 389.04 1062 385.56 1062 382C1061.99 377.228 1060.1 372.652 1056.72 369.278C1053.35 365.903 1048.77 364.005 1044 364ZM1056.46 384.769H1053.25L1050.82 390.827C1050.72 391.084 1050.54 391.305 1050.31 391.46C1050.08 391.615 1049.81 391.698 1049.54 391.698C1049.26 391.698 1048.99 391.615 1048.76 391.46C1048.53 391.305 1048.35 391.084 1048.25 390.827L1044 380.19L1039.75 390.827C1039.64 391.084 1039.47 391.305 1039.24 391.46C1039.01 391.615 1038.74 391.698 1038.46 391.698C1038.18 391.698 1037.91 391.615 1037.68 391.46C1037.46 391.305 1037.28 391.084 1037.18 390.827L1034.75 384.769H1031.54C1031.17 384.769 1030.82 384.623 1030.56 384.364C1030.3 384.104 1030.15 383.752 1030.15 383.385C1030.15 383.017 1030.3 382.665 1030.56 382.406C1030.82 382.146 1031.17 382 1031.54 382H1033.65L1031.64 376.981C1031.57 376.812 1031.53 376.631 1031.54 376.449C1031.54 376.267 1031.58 376.087 1031.65 375.919C1031.79 375.581 1032.06 375.313 1032.4 375.176C1032.74 375.038 1033.13 375.041 1033.47 375.185C1033.8 375.329 1034.07 375.601 1034.21 375.942L1038.46 386.58L1042.71 375.942C1042.82 375.685 1042.99 375.465 1043.22 375.309C1043.45 375.154 1043.72 375.071 1044 375.071C1044.28 375.071 1044.55 375.154 1044.78 375.309C1045.01 375.465 1045.18 375.685 1045.29 375.942L1049.54 386.58L1053.79 375.942C1053.93 375.601 1054.2 375.329 1054.53 375.185C1054.87 375.041 1055.26 375.038 1055.6 375.176C1055.94 375.313 1056.21 375.581 1056.35 375.919C1056.5 376.258 1056.5 376.64 1056.36 376.981L1054.35 382H1056.46C1056.83 382 1057.18 382.146 1057.44 382.406C1057.7 382.665 1057.85 383.017 1057.85 383.385C1057.85 383.752 1057.7 384.104 1057.44 384.364C1057.18 384.623 1056.83 384.769 1056.46 384.769Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404 364C1400.44 364 1396.96 365.056 1394 367.034C1391.04 369.011 1388.73 371.823 1387.37 375.112C1386.01 378.401 1385.65 382.02 1386.35 385.512C1387.04 389.003 1388.75 392.211 1391.27 394.728C1393.79 397.245 1397 398.96 1400.49 399.654C1403.98 400.349 1407.6 399.992 1410.89 398.63C1414.18 397.267 1416.99 394.96 1418.97 392C1420.94 389.04 1422 385.56 1422 382C1421.99 377.228 1420.1 372.652 1416.72 369.278C1413.35 365.903 1408.77 364.005 1404 364ZM1410.92 391.692H1397.08C1396.71 391.692 1396.36 391.546 1396.1 391.287C1395.84 391.027 1395.69 390.675 1395.69 390.308C1395.69 389.94 1395.84 389.588 1396.1 389.329C1396.36 389.069 1396.71 388.923 1397.08 388.923C1397.81 388.923 1398.52 388.631 1399.04 388.112C1399.55 387.593 1399.85 386.888 1399.85 386.154V383.385H1397.08C1396.71 383.385 1396.36 383.239 1396.1 382.979C1395.84 382.719 1395.69 382.367 1395.69 382C1395.69 381.633 1395.84 381.281 1396.1 381.021C1396.36 380.761 1396.71 380.615 1397.08 380.615H1399.85V376.462C1399.85 375.246 1400.17 374.052 1400.77 373C1401.38 371.948 1402.26 371.074 1403.31 370.466C1404.36 369.859 1405.55 369.539 1406.77 369.539C1407.98 369.539 1409.18 369.859 1410.23 370.466C1410.54 370.655 1410.76 370.956 1410.85 371.306C1410.94 371.656 1410.89 372.027 1410.71 372.339C1410.53 372.652 1410.23 372.881 1409.88 372.979C1409.54 373.077 1409.16 373.035 1408.85 372.863C1408.21 372.499 1407.5 372.307 1406.77 372.307C1406.04 372.307 1405.32 372.499 1404.69 372.864C1404.06 373.228 1403.54 373.753 1403.17 374.384C1402.81 375.016 1402.62 375.732 1402.62 376.462V380.615H1405.38C1405.75 380.615 1406.1 380.761 1406.36 381.021C1406.62 381.281 1406.77 381.633 1406.77 382C1406.77 382.367 1406.62 382.719 1406.36 382.979C1406.1 383.239 1405.75 383.385 1405.38 383.385H1402.62V386.154C1402.62 387.127 1402.36 388.082 1401.87 388.923H1410.92C1411.29 388.923 1411.64 389.069 1411.9 389.329C1412.16 389.588 1412.31 389.94 1412.31 390.308C1412.31 390.675 1412.16 391.027 1411.9 391.287C1411.64 391.546 1411.29 391.692 1410.92 391.692Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188 436C1184.44 436 1180.96 437.056 1178 439.034C1175.04 441.011 1172.73 443.823 1171.37 447.112C1170.01 450.401 1169.65 454.02 1170.35 457.512C1171.04 461.003 1172.75 464.211 1175.27 466.728C1177.79 469.245 1181 470.96 1184.49 471.654C1187.98 472.349 1191.6 471.992 1194.89 470.63C1198.18 469.267 1200.99 466.96 1202.97 464C1204.94 461.04 1206 457.56 1206 454C1205.99 449.228 1204.1 444.652 1200.72 441.278C1197.35 437.903 1192.77 436.005 1188 436ZM1181.08 445.692H1194.92C1195.29 445.692 1195.64 445.838 1195.9 446.098C1196.16 446.358 1196.31 446.71 1196.31 447.077C1196.31 447.444 1196.16 447.796 1195.9 448.056C1195.64 448.316 1195.29 448.462 1194.92 448.462H1181.08C1180.71 448.462 1180.36 448.316 1180.1 448.056C1179.84 447.796 1179.69 447.444 1179.69 447.077C1179.69 446.71 1179.84 446.358 1180.1 446.098C1180.36 445.838 1180.71 445.692 1181.08 445.692ZM1199.08 460.923C1199.08 461.29 1198.93 461.642 1198.67 461.902C1198.41 462.162 1198.06 462.308 1197.69 462.308H1193.54C1192.44 462.308 1191.38 461.87 1190.6 461.091C1189.82 460.312 1189.38 459.256 1189.38 458.154V454H1186.62C1186.61 456.203 1185.74 458.314 1184.18 459.872C1182.62 461.429 1180.51 462.305 1178.31 462.308C1177.94 462.308 1177.59 462.162 1177.33 461.902C1177.07 461.642 1176.92 461.29 1176.92 460.923C1176.92 460.556 1177.07 460.204 1177.33 459.944C1177.59 459.684 1177.94 459.538 1178.31 459.538C1179.78 459.538 1181.19 458.955 1182.22 457.916C1183.26 456.878 1183.85 455.469 1183.85 454H1179.69C1179.33 454 1178.97 453.854 1178.71 453.594C1178.45 453.335 1178.31 452.983 1178.31 452.615C1178.31 452.248 1178.45 451.896 1178.71 451.636C1178.97 451.377 1179.33 451.231 1179.69 451.231H1196.31C1196.67 451.231 1197.03 451.377 1197.29 451.636C1197.55 451.896 1197.69 452.248 1197.69 452.615C1197.69 452.983 1197.55 453.335 1197.29 453.594C1197.03 453.854 1196.67 454 1196.31 454H1192.15V458.154C1192.15 458.521 1192.3 458.873 1192.56 459.133C1192.82 459.393 1193.17 459.538 1193.54 459.538H1196.31V458.154C1196.31 457.787 1196.45 457.434 1196.71 457.175C1196.97 456.915 1197.33 456.769 1197.69 456.769C1198.06 456.769 1198.41 456.915 1198.67 457.175C1198.93 457.434 1199.08 457.787 1199.08 458.154V460.923Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 508C1322.1 508 1314 516.1 1314 526C1314 535.9 1322.1 544 1332 544C1341.9 544 1350 535.9 1350 526C1350 516.1 1341.99 508 1332 508ZM1340.28 534.01C1339.92 534.549 1339.29 534.73 1338.75 534.37C1334.52 531.76 1329.21 531.218 1322.91 532.658C1322.28 532.841 1321.74 532.39 1321.56 531.85C1321.38 531.219 1321.83 530.68 1322.37 530.5C1329.21 528.969 1335.15 529.6 1339.83 532.48C1340.46 532.75 1340.55 533.469 1340.28 534.01ZM1342.44 529.06C1341.99 529.69 1341.18 529.96 1340.55 529.51C1335.69 526.54 1328.31 525.64 1322.64 527.44C1321.92 527.62 1321.11 527.26 1320.93 526.54C1320.75 525.82 1321.11 525.008 1321.83 524.828C1328.4 522.85 1336.5 523.842 1342.08 527.26C1342.62 527.531 1342.89 528.43 1342.44 529.06ZM1342.62 524.02C1336.86 520.6 1327.23 520.24 1321.74 521.951C1320.84 522.22 1319.94 521.68 1319.67 520.87C1319.4 519.969 1319.94 519.07 1320.75 518.799C1327.14 516.908 1337.67 517.268 1344.33 521.23C1345.14 521.68 1345.41 522.76 1344.96 523.57C1344.51 524.201 1343.43 524.469 1342.62 524.02Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10831_123661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1440 310) scale(851.5 228.892)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10831_123661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    fill: "white",
    transform: "translate(0 -230)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForex);
export default __webpack_public_path__ + "static/media/forex.b3facc5ddee1866b6ff15d191a8c16ff.svg";
export { ForwardRef as ReactComponent };